import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseContractExtendedTemplates = [
  {
    id: '-105001',
    language: Language.EN,
    subject: 'Extension of the lease term',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_EXTENDED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerns: term extension of the lease located at <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Your lease contract has been extended to: <strong>{{formatDate lease.endDate}}</strong>.</p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-105002',
    language: Language.FR,
    subject: 'Extension de la durée du bail',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_EXTENDED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerne: extension de la durée du bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Votre bail a été prolongé jusqu'au: <strong>{{formatDate lease.endDate}}</strong>.</p>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-105003',
    language: Language.NL,
    subject: 'Verlenging van de huur termijn',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_EXTENDED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreffende: verlenging van uw huurcontract gelegen te <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Uw huurcontract wordt verlengd tot: <strong>{{formatDate lease.endDate}}</strong>.</p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-105004',
    language: Language.DE,
    subject: 'Verlängerung der Mietdauer',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_EXTENDED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreff: Verlängerung der Laufzeit des Mietvertrags in <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Ihr Mietvertrag wurde verlängert bis: <strong>{{formatDate lease.endDate}}</strong>.</p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
